import { getIconByOrderStatus, getTextByOrderStatus } from "@domain/enums/local/getTextByOrderStatus";
import { PrefetchLink } from "@boundary/components/prefetchLink";
import type { OrderHistoryListItem } from "@domain/dtos/models/order.models";
import styles from "./historyItem.module.scss";

interface HistoryItemProps {
  item: OrderHistoryListItem;
  isActive?: boolean;
}

export function HistoryItem({ item, isActive = false }: HistoryItemProps) {
  return (
    <li className={styles.card}>
      <PrefetchLink to={`/order/${item.order_number}`} className={styles.link}>
        <div className={styles.textContent}>
          <div className={styles.titleGroup}>
            <p className={styles.title}>Заказ {item.order_number}</p>
            {isActive && item.time_to_ready && (
              <p className={styles.subtitle}>Будет готов примерно в {item.time_to_ready}</p>
            )}
          </div>
          <div className={styles.statusBadge}>
            <div className={styles.statusIcon}>
              {getIconByOrderStatus(item.status)}
            </div>
            <span className={styles.statusText}>{getTextByOrderStatus(item.status)}</span>
          </div>
        </div>
      </PrefetchLink>
      <div className={styles.imageContainer}>
        <img
          src="/assets/map/printer-big.png"
          alt=""
          className={styles.image}
        />
      </div>
    </li>
  );
}
